import { EmoticonSickIcon } from './EmoticonSickIcon';

/**
 * author: Google
 * id 523F5AB1-3598-40F1-AAB5-6DF361FF6970
 * name emoticon-sick
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-sick.svg
 * tags
 * - Emoji 
 * - Medical / Hospital 
 */
export const EmojiSickIcon = EmoticonSickIcon;
export default EmojiSickIcon